export default __webpack_public_path__ + "static/media/ISRO.d95cdaca.png";